import React, { useState } from "react";
import SelectBox from "../../../components/SelectBox";
import {
  alertList,
  siteDetails,
  companyDetails,
} from "../../redux/api/dummyJson";

const AlertEscalationAdmin = ({ site, setAlertData, alertData }) => {
  const [data, setData] = useState([]);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  // console.log("company", selectedCompany);

  // Table data
  const [editIndex, setEditIndex] = useState(null);
  const [tempTime, setTempTime] = useState("");

  const handleCancel = () => {
    setEditIndex(null);
    setTempTime("");
  };

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {alertData?.length}
        </h2>
      </div>

      <table className="table table-bordered m-3">
        <thead>
          <tr className="text-center">
            <th>S.No</th>
            <th>Severity</th>
            <th>Groups</th>
            <th>Time (mins)</th>
            {/* <th>Actions</th> */}
          </tr>
        </thead>
        <tbody>
          {alertData?.map((row, i) => {
            const isEditing = editIndex === i;
            return (
              <tr key={i} className="text-center">
                <td>{i + 1}</td>
                <td>{row?.severity}</td>
                <td className="text-nowrap">
                  {row?.from_group ? `Group  ${row?.from_group} ` : ""}
                  {row?.to_group ? `→ Group  ${row?.to_group}` : ""}
                </td>
                <td>
                  {isEditing ? (
                    <input
                      type="text"
                      value={tempTime}
                      onChange={(e) => setTempTime(e.target.value)}
                      className="input-box text-center w-50"
                    />
                  ) : (
                    <input
                      type="text"
                      value={row?.escalation_minutes}
                      disabled
                      className="input-box text-center w-50"
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AlertEscalationAdmin;
